import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { Container, Content, Image, Info, Divider } from './styles';

export default function PortabilitySession() {
  const { t } = useTranslation();

  return (
    <Container>
      <Content>
        <Image />
        <Info>
          <header>
            <Typography component="span" variant="h1">
              {t(
                'Faça seu tratamento em qualquer clínica Vialaser, sem custos adicionais',
              )}
            </Typography>
          </header>
          <Divider />
          <div>
            <Typography component="p">
              {t(
                'Continue o seu tratamento de depilação em qualquer uma de nossas clínicas, sem pagar mais por isso',
              )}
            </Typography>
            <Typography component="p">
              {t(
                'Ao fechar seu contrato, cadastramos sua biometria para você desfrutar do nosso serviço onde quer que esteja Ah Biometria significa a leitura da nossa impressão digital!',
              )}
            </Typography>
          </div>
        </Info>
      </Content>
    </Container>
  );
}
